import React, { Component } from 'react';
import '../myutils';
import {
    translate
} from 'react-admin'; 
import BookIcon from '@material-ui/icons/Book';
import Button from '@material-ui/core/Button';
import Delete from '@material-ui/icons/Delete';
import { configAPI } from '../config'
import { push as pushAction } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { refreshView as refreshViewAction } from 'ra-core';

export const TemplateIcon = BookIcon;

class DeleteFile extends Component {

    state = {
        open: false,
    };
    constructor(props) {
        super(props);
        this.state = {
            record: false
        }
    }

    handleClickDelete = (e, record) => {
        this.handleClose(e);
        if (this.props.handleCloseMenu) this.props.handleCloseMenu();

        const { push } = this.props;

        if (record) {
            const ReqDelete = new Request(configAPI.api.prod + '/FileAction?token=' + sessionStorage.B.encodeDecode() + '&action=delete&what=' + record.what);
            fetch(ReqDelete)
                .then(response => response.json())
                .then(json => {

                    if (json.responseStatus === 'OK') {
                        json.reports.forEach(element => {
                            var dPath = element.what.replace('ivr2:','');
                            sessionStorage.setItem('AllDirs', sessionStorage.AllDirs.replace(','+dPath,''));
                        });
                        push('/IVR?filter=' + sessionStorage.Filter);
                        const {refreshView} = this.props;
                        refreshView();

                    }
                });
        }
        else {
            var data = new FormData();
            data.append("token", sessionStorage.B.encodeDecode());
            data.append("action", "delete");
            if (this.props.message) data.append("what", this.props.path)
            else {
                var whats = sessionStorage.getItem('selectedFile').split('//..//');
                whats.pop();
                whats.forEach((what, index) => {
                    data.append("what" + index, what);
                });
            }
            return fetch(configAPI.api.prod + 'FileAction', {
                method: "POST",
                body: data
            }).then((resp) => {

                if (resp.ok) {
                    sessionStorage.setItem('selectedFile', '');
                    const {refreshView} = this.props;
                    refreshView();
                    push('/IVR?filter=' + sessionStorage.Filter);
                }
            })
        }
    }

    handleClickOpen = (e) => {
        e.stopPropagation();
        this.setState({ open: true });
    };

    handleClose = (e) => {
        e.stopPropagation();
        this.setState({ open: false });
    };

    render() {
        const { translate, record } = this.props;
        return (
            <Tooltip title={translate(`trans.delete`)}>
                <IconButton onClick={(e) => this.handleClickOpen(e)}>
                    <Delete/>
                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{translate(`trans.approveDelete`)}</DialogTitle>
                        <DialogActions>
                            <Button onClick={(e) => this.handleClose(e)} color="primary">
                                {translate(`trans.cancel`)}
                            </Button>
                            <Button onClick={(e) => this.handleClickDelete(e, record)} color="primary" autoFocus>
                                {translate(`trans.ok`)}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </IconButton>
            </Tooltip>
        );
    }
}

DeleteFile.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

const enhance = connect(
    null,
    { refreshView: refreshViewAction }
  );
  
export default enhance(connect(null, {
    push: pushAction,
})(translate(DeleteFile)));
